export default __webpack_public_path__ + "static/media/Zone-4-Master-Plan.0afc1158.png";